interface ResponsiveOptionsConfig {
  lowestThreshold?: number;
  minCards?: number;
  maxCards?: number;
  interval?: number;
}

interface CarouselResponsiveOption {
  breakpoint: string;
  numVisible: number;
  numScroll: number;
}

export const buildResponsiveOptions = ({
  lowestThreshold = 600,
  minCards = 1,
  maxCards = 4,
  interval = 200,
}: ResponsiveOptionsConfig = {}): CarouselResponsiveOption[] => {
  const options: CarouselResponsiveOption[] = [];

  for (let numVisible = minCards; numVisible <= maxCards; numVisible++) {
    options.push({
      breakpoint: `${lowestThreshold + (numVisible - minCards) * interval}px`,
      numVisible: numVisible,
      numScroll: numVisible,
    });
  }

  return options;
};
